// Stop any initial scroll to a hash
window.scrollTo( 0, 0 );

// Function to scroll to a specific heading
function scrollToHash( linkHref ) {

    // Get the heading we should scroll to
    let elementToScrollTo = document.querySelector( linkHref );

    // Set a variable for the eventual scroll position
    let scrollToPosition = 0

    // Add the vertical position of the heading
    scrollToPosition += window.scrollY + elementToScrollTo.getBoundingClientRect().top;

    // Remove the height of the mobile header
    if ( mobileHeader ) {
      scrollToPosition -= mobileHeader.getBoundingClientRect().height;
    }

    // Remove the height of the content header
    if ( headingBackWrapper ) {
      scrollToPosition -= headingBackWrapper.getBoundingClientRect().height;
    }

    // Remove the height of the admin bar
    if ( adminBar = document.querySelector( '#wpadminbar' ) ) {
      scrollToPosition -= adminBar.getBoundingClientRect().height;
    }

    // Remove a bit more for spacing
    scrollToPosition -= 30;

    // Scroll to that point
    window.scrollTo( {
      behavior: 'smooth',
      left: 0,
      top: scrollToPosition,
    } );

    // Focus on the element (if it's focusable)
    elementToScrollTo.focus();

}

// Add a listener for the page being loaded
window.addEventListener( 'load', function( event ) {

  // If there's a hash
  if ( window.location.hash ) {

    // If it's a step link
    if ( window.location.hash.includes( 'step-by-step' ) ) {

      let step = document.querySelector( window.location.hash );
      let stepShow = step.querySelector( '.heading' );

      step.querySelector( '.content' ).style.display = 'block';
      step.querySelector( '.show-hide-text' ).innerHTML = 'Hide';
      stepShow.setAttribute( 'aria-expanded', 'true' );
    }

    // Scroll to it
    scrollToHash( window.location.hash );

  }

} );

// Loop through any links that aren't in an in-page nav (they're dealt with in the block js)
document.querySelectorAll( 'a[ href^="#" ]:not( #in-page-nav-list-dropdown .link, #in-page-nav-list-inline .link )' ).forEach( function( link ) {

  // Add an event listener for a click
  link.addEventListener( 'click', function( event ) {

    // Stop the link being followed so we can control the scroll
    event.preventDefault();

    // Get the href of the clicked link
    let linkHref = event.currentTarget.getAttribute( 'href' );

    // Scroll to that point
    scrollToHash( linkHref );

    // Add the URL hash
    window.history.pushState( {}, '', window.location.origin + window.location.pathname + linkHref );

  } );

} );
